import { render } from "./InventoryDetails.vue?vue&type=template&id=658eefce&scoped=true"
import script from "./InventoryDetails.vue?vue&type=script&lang=js"
export * from "./InventoryDetails.vue?vue&type=script&lang=js"

import "./InventoryDetails.vue?vue&type=style&index=0&id=658eefce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658eefce"]])

export default __exports__